module.exports = __webpack_public_path__ + "media/control_acceso/face_plate-9d250ac4.webp";